<template>
    <v-select
      v-model="selectedMeal"
      :items="mealOptions"
      item-text="name"
      item-value="name"
      :label="mealType"
      @change="updateMeal"
    ></v-select>
  </template>
  
  <script>
  export default {
    props: ['meal', 'mealType'],
    data() {
      return {
        selectedMeal: '',
        mealOptions: [
          { name: 'Standard Meal', points: 5 },
          { name: 'Vegetarian Meal', points: 4 },
          { name: 'Special Meal', points: 7 },
          { name: 'No Meal', points: 0 },
        ],
      };
    },
    methods: {
      updateMeal() {
        const selected = this.mealOptions.find(option => option.name === this.selectedMeal);
        this.$emit('update:meal', selected || { name: '', points: 0 });
      },
    },
    created() {
      this.selectedMeal = this.meal.name;
    },
  };
  </script>